import { Link } from "react-router-dom";

import { usePageMeta } from "../hooks/usePageMeta";

export const NotFoundPage = () => {
  usePageMeta("Page not found — CatalyxLabs");

  return (
    <div className="page-header">
      <span className="eyebrow">404</span>
      <h1 className="page-header__title">We can&apos;t find that page</h1>
      <p className="page-header__lede">
        The link may be out of date. Head back to the homepage, or tell us what
        you were looking for.
      </p>
      <div className="page-header__actions">
        <Link to="/" className="btn btn--primary">
          Back to home
        </Link>
        <Link to="/contact" className="btn btn--secondary">
          Contact us
        </Link>
      </div>
    </div>
  );
};
